import React, { useEffect, useRef, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { ScrollPanel } from 'primereact/scrollpanel'
import Markdown from 'react-markdown'
import { Menu } from 'primereact/menu'
import { Splitter, SplitterPanel } from 'primereact/splitter'
import remarkGfm from 'remark-gfm'
import { PanelMenu } from 'primereact/panelmenu'
import { Badge } from 'primereact/badge'
import { Tree } from 'primereact/tree'
import { Toast } from 'primereact/toast'
import { ContextMenu } from 'primereact/contextmenu'

export default function ManualUsuario() {
    const [filteredMenuItems, setFilteredMenuItems] = useState([])

    const [nodes, setNodes] = useState([])
    const [selectedContent, setSelectedContent] = useState('')
    const [expandedKeys, setExpandedKeys] = useState({})
    const [selectedNodeKey, setSelectedNodeKey] = useState(null)
    const toast = useRef(null)
    const cm = useRef(null)

    useEffect(() => {
        if (selectedContent.length === 0) {

            setExpandedKeys({ '01': true })
            setSelectedNodeKey('01.01')
            setContentFromFile('introducao_visao_geral.md')

        }
    })

    // Dados do menu - podem ser links para diferentes partes do manual
    const menuItems = [
        {
            label: 'Introdução',
            key: '01',
            icon: '',
            children: [
                { label: 'Visão Geral', key: '01.01', icon: '', command: () => setContentFromFile('introducao_visao_geral.md'), data: 'Um dado' },
                { label: 'Bases de empresas', key: '01.02', icon: '', command: () => setContentFromFile('introducao_bases_empresas.md') },
            ],
            template: itemRenderer,
        },
        {
            label: 'Cadastro',
            key: '02',
            icon: '',
            children: [
                { label: 'Pessoa física', key: '02.01', icon: '', command: () => setContentFromFile('cadastro_pessoa_fisica.md') },
                { label: 'Usuário', key: '02.02', icon: '', command: () => setContentFromFile('cadastro_pessoa_usuario.md') },
                {
                    label: 'Produto',
                    key: '02.03',
                    icon: '',
                    children: [
                        { label: 'Produto', key: '02.03.01', icon: '', command: () => setContentFromFile('cadastro_produto_produto.md') },
                        { label: 'Produto - Cor', key: '02.03.02', icon: '', command: () => setContentFromFile('cadastro_produto_cor.md') },
                        { label: 'Produto - Marca', key: '02.03.03', icon: '', command: () => setContentFromFile('cadastro_produto_marca.md') },
                        { label: 'Produto - Tamanho', key: '02.03.04', icon: '', command: () => setContentFromFile('cadastro_produto_tamanho.md') },
                        { label: 'Produto - Unidade', key: '02.03.05', icon: '', command: () => setContentFromFile('cadastro_produto_unidade.md') },
                        { label: 'Produto - Endereços de produtos', key: '02.03.06', icon: '', command: () => setContentFromFile('cadastro_produto_endereco_produto.md') },
                    ]
                },
                {
                    label: 'Fiscal',
                    key: '02.04',
                    icon: '',
                    children: [
                        { label: 'Série', key: '02.04.01', icon: '', command: () => setContentFromFile('cadastro_fiscal_serie.md') },
                        { label: 'CFOP', key: '02.04.02', icon: '', command: () => setContentFromFile('cadastro_fiscal_cfop.md') },
                        { label: 'Operação Fiscal (Todas)', key: '02.04.03', icon: '', command: () => setContentFromFile('cadastro_fiscal_operacao_fiscal.md') },
                        { label: 'Tributo', key: '02.04.04', icon: '', command: () => setContentFromFile('cadastro_fiscal_tributo.md') },
                        {
                            label: 'Listas',
                            key: '02.04.05',
                            icon: '',
                            children: [
                                { label: 'Tipo de lista de NCM', key: '02.04.05.01', icon: '', command: () => setContentFromFile('cadastro_fiscal_tipo_lista_ncm.md') },
                                { label: 'Tipo de lista de CEST/NCM', key: '02.04.05.02', icon: '', command: () => setContentFromFile('cadastro_fiscal_tipo_lista_cest_ncm.md') },
                                { label: 'Lista de NCM', key: '02.04.05.03', icon: '', command: () => setContentFromFile('cadastro_fiscal_lista_ncm.md') },
                                { label: 'Lista de CEST/NCM', key: '02.04.05.04', icon: '', command: () => setContentFromFile('cadastro_fiscal_lista_cest_ncm.md') },
                                { label: 'Lista de UF', key: '02.04.05.05', icon: '', command: () => setContentFromFile('cadastro_fiscal_lista_uf.md') },
                                { label: 'Lista de município', key: '02.04.05.06', icon: '', command: () => setContentFromFile('cadastro_fiscal_lista_municipio.md') },
                            ]
                        },
                        {
                            label: 'Códigos',
                            key: '02.04.06',
                            icon: '',
                            children: [
                                { label: 'Classificação tributária', key: '02.04.06.01', icon: '', command: () => setContentFromFile('cadastro_fiscal_classificacao_tributaria.md') },
                                { label: 'CST/CSOSN do ICMS', key: '02.04.06.02', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_icms.md') },
                                { label: 'CST do PIS', key: '02.04.06.03', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_pis.md') },
                                { label: 'CST do COFINS', key: '02.04.06.04', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_cofins.md') },
                                { label: 'CST do IPI', key: '02.04.06.05', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_ipi.md') },
                                { label: 'CST do ISS', key: '02.04.06.06', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_iss.md') },
                                { label: 'CST da CBS', key: '02.04.06.07', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_cbs.md') },
                                { label: 'CST do IBS', key: '02.04.06.08', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_ibs.md') },
                                { label: 'CST do IS', key: '02.04.06.09', icon: '', command: () => setContentFromFile('cadastro_fiscal_cst_is.md') },
                            ]
                        },
                    ]
                },
            ],
        },
        {
            label: 'Configuração',
            key: '03',
            icon: '',
            children: [
                { label: 'Configurações do Sistema', key: '03.01', icon: '', command: () => setContentFromFile('configuracao_configuracao_sistema.md') },
                { label: 'Empresa', key: '03.02', icon: '', command: () => setContentFromFile('configuracao_empresa.md') },
            ],
        },
    ]

    async function loadContentFromFile(filePath) {
        try {
            filePath = '/manualusuario/' + filePath
            const response = await fetch(filePath)
            return await response.text()
        } catch (error) {
            console.error('Erro ao carregar o conteúdo do arquivo:', error)
            setSelectedContent('Erro ao carregar o conteúdo.')
        }
    }
    const sanitizeManualContent = (text = '') => {
        const EXPORT_BLOCK_REGEX = /<export\b([^>]*)>([\s\S]*?)<\/export>/gi
        return text.replace(EXPORT_BLOCK_REGEX, (match, attrs = '', inner = '') => {
            const visibleMatch = attrs.match(/\bvisible\s*=\s*(["']?)(true|false)\1/i)
            const isVisible = visibleMatch ? visibleMatch[2].toLowerCase() === 'true' : true
            return isVisible ? inner : ''
        })
    }

    const setContentFromFile = async (filePath) => {
        const raw = await loadContentFromFile(filePath)
        setSelectedContent(sanitizeManualContent(raw))
    }

    // Função de filtro para pesquisa (recursiva)
    const onSearch = (event) => {
        const query = event.target.value.toLowerCase()

        if (query) {
            const filterItemsRecursive = (items) => {
                return items.map((item) => {
                    // Verificar se o item atual corresponde à busca
                    const itemMatches = item.label.toLowerCase().includes(query)

                    // Se o item tem filhos, filtrar recursivamente
                    let filteredChildren = []
                    if (item.children) {
                        filteredChildren = filterItemsRecursive(item.children)
                    }

                    // Incluir o item se:
                    // 1. O próprio item corresponde à busca, OU
                    // 2. Algum filho corresponde à busca
                    if (itemMatches || filteredChildren.length > 0) {
                        return {
                            ...item,
                            children: filteredChildren.length > 0 ? filteredChildren : item.children
                        }
                    }

                    return null
                }).filter(item => item !== null)
            }

            const filteredItems = filterItemsRecursive(menuItems)
            setFilteredMenuItems(filteredItems)
        } else {
            setFilteredMenuItems([])
        }
    }

    function itemRenderer(item, options) {
        <a className="flex align-items-center px-3 py-2 cursor-pointer" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.badge && <Badge className="ml-auto" value={item.badge} />}
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
    }

    return (
        <div className='flex border-round-lg min-w-full p-2 z-0' style={{ background: 'var(--surface-card)', minHeight: 'calc(100vh - 50px)' }}>
            <Toast ref={toast} />
            <Splitter className='w-full border-0'>
                <SplitterPanel
                    className="flex flex-column align-items-start justify-content-start "
                    size={25}
                    minSize={25}
                >

                    {/* SIDEBAR  */}

                    <span id='manualUsuario' className='ml-2 mb-4 mt-4 font-bold'>Manual do usuário</span>
                    <div className="flex w-full mx-2 mb-2">
                        <div className="mr-3 w-full">
                            <InputText
                                placeholder="Pesquisar..."
                                onChange={onSearch}
                                className="w-full"
                            />
                        </div>
                    </div>


                    <ContextMenu model={filteredMenuItems.length ? filteredMenuItems : menuItems} ref={cm} />

                    <ScrollPanel style={{ maxHeight: 'calc(100vh - 200px)', width: '100%' }}>
                        <Tree
                            selectionMode='single'
                            value={filteredMenuItems.length ? filteredMenuItems : menuItems}
                            expandedKeys={expandedKeys}
                            onToggle={(e) => setExpandedKeys(e.value)}
                            contextMenuSelectionKey={selectedNodeKey}
                            onContextMenuSelectionChange={(e) => setSelectedNodeKey(e.value)}
                            onContextMenu={(e) => cm.current.show(e.originalEvent)}
                            className="text-sm"
                            style={{ border: 'none', fontSize: '0.9rem' }}
                            onSelect={e => {
                                const node = e.node

                                // Alterna expansão ao clicar no texto
                                if (node.children) {
                                    setExpandedKeys((prev) => {
                                        const next = { ...prev }
                                        if (next[node.key]) {
                                            delete next[node.key]
                                        } else {
                                            next[node.key] = true
                                        }
                                        return next
                                    })
                                }

                                // Executa comando se houver
                                if (node.command) node.command()

                                setSelectedNodeKey(node.key)
                            }}
                            nodeTemplate={(node) => (
                                <span className={`${node.key === selectedNodeKey ? 'font-bold' : ''}`}>{node.label}</span>
                            )}

                        />
                    </ScrollPanel>

                    {/* <PanelMenu
                        model={filteredMenuItems.length ? filteredMenuItems : menuItems}
                        className="w-full md:w-20rem"
                        multiple={true}
                        toggleable={false}
                    /> */}

                    {/* <ScrollPanel >
                        <Menu className='border-0'
                            style={{ width: '100%' }}
                            model={filteredMenuItems.length ? filteredMenuItems : menuItems}
                        />
                    </ScrollPanel> */}
                </SplitterPanel>

                {/* CONTEÚDO  */}

                <SplitterPanel className="pl-4" size={75}>
                    <ScrollPanel >
                        <Markdown
                            remarkPlugins={[remarkGfm]}
                            components={{
                                table({ node, ...props }) { return (<table style={{ borderCollapse: 'collapse', marginBottom: '1rem', }}{...props} />) },
                                th({ node, ...props }) { return (<th style={{ border: '1px solid #ccc', padding: '8px', backgroundColor: '#f3f3f3', textAlign: 'left', }}{...props} />) },
                                td({ node, ...props }) { return (<td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left', }}{...props} />) },
                                tr({ node, ...props }) { return <tr {...props} /> },
                            }}
                        >
                            {selectedContent}
                        </Markdown>

                    </ScrollPanel>
                </SplitterPanel>
            </Splitter>
        </div >
    )
}
